<template>
  <div class="container-fluid">
    <Card>
      <template v-slot:header>
        <h3>فایلهای بارگذاری شده من</h3>
        <hr />
      </template>
      <template v-slot:content>
        <EducationTable :FromMyFiles="true" :tablename="File" :label="File"></EducationTable>
      </template>
    </Card>
  </div>
</template>
<script>
import Card from '@/components/Card/Card.vue'
import EducationTable from './Component/educationTable.vue'
export default {
  data() {
    return {}
  },
  components: { Card, EducationTable },
}
</script>
